import React, { useRef, useEffect, useState} from 'react';
import {get_Txy_data, get_y1_T,} from './physical_models.js';
import {OutputTable_Compare, OutputGraph, OutputGraph_xy} from './output_graph.js';

const CN=0, EN = 1;

export function VLE_exp({params}){

    const {selectedModel, selectedSystem, tMax, tMin, lang} = params;
    const [P_in, setP_in] = useState(1.013);
    const [data, setData] = useState([]);
    const {Txy_data, Tm, xm, azeotrope} = get_Txy_data(P_in,selectedModel, selectedSystem);

    const setting_cap = (lang===CN) ? "设定实验压力以做对比" : 'Set a pressure for comparison';
    const azeo_T_cap = (lang===CN) ? '模型恒沸温度' : 'Simulated Azeo T';
    const azeo_X_cap = (lang===CN) ? '模型恒沸组成' : 'Simulated Azeo x1';
    const azeo_Te_cap = (lang===CN) ? '实验恒沸温度' : 'Experimental Azeo T';
    const azeo_Xe_cap = (lang===CN) ? '实验恒沸组成' : 'Experimental Azeo x1';

    const clearData_cap = (lang===CN) ? '清除实验数据' : 'Clear All Data';
    const addData_cap = (lang===CN) ? '上传/追加数据' : 'Upload/Append data';
    const dataFormat_cap = (lang===CN) ? '上传实验数据.csv文件, 包含Tb(C),x1,y1三列' : 'Upload exp .csv data, including cols: Tb(C),x1,y1'

    const press_unit_cn = 'bar', press_unit_en = 'bar';
    const press_unit = (lang===CN) ? press_unit_cn : press_unit_en;
    const Tm_cap_cn = '模型恒沸点 =', Tm_cap_en = 'TheoreticalTm =';
    const Tm_cap = (lang===CN) ? Tm_cap_cn : Tm_cap_en;
    const txytitle_cap_cn = 'T-x-y 相图', txytitle_cap_en = 'T-x-y Phase Diagram';
    const txytitle_cap = (lang===CN) ? txytitle_cap_cn : txytitle_cap_en;
    const xytitle_cap_cn = 'x-y 相图', xytitle_cap_en = 'x-y Phase Diagram';
    const xytitle_cap= (lang===CN) ? xytitle_cap_cn : xytitle_cap_en;

    const P_in_Change = (e)=>{
        const newP = e.target.value;
        setP_in(newP);
      } 


    const handleDataLoaded = (csvData) => {
        // Example: Convert raw text into an array of objects or any format your plotting library needs
        const rows = csvData.split('\n').map(row => row.trim()).filter(row => row);
        const headers = rows[0].split(',');
        const requiredHeaders = ['Tb(C)', 'x1', 'y1'];
        const headerIncomplete_cap = (lang===CN)? "上传数据必须包含Tb(C),x1,y1列": 'CSV file should include Tb(C),x1,y1 triples'

        if (!requiredHeaders.every(header=>headers.includes(header))) {
            alert(headerIncomplete_cap);
            return;
        }

        const newData = rows.slice(1).map(row => {
            const values = row.split(',');
            const obj = headers.reduce((object, header, index) => {
                if (requiredHeaders.includes(header)) {
                    const v = parseFloat(values[index])
                    //alert(v+273.15);
                    if (header==='Tb(C)') 
                        object['Tb'] = 273.15 + v;
                    else
                        object[header] = v;
                }
                return object;
            }, {});
            return obj;
        });

        setData([...data, ...newData]);

      };
    
      const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (!file) {
          return;
        }
        event.target.value = null;
    
        const reader = new FileReader();
        reader.onload = (e) => {
          const text = e.target.result;
          // Process the text data here and then pass it to the parent component or store it in state
          handleDataLoaded(text);
        };
        reader.readAsText(file);
      };


    const compareData = data.map(d=>{ const {y1, T_bubble} = get_y1_T(P_in,d.x1,selectedModel, selectedSystem);
                                      return {x1: d.x1, y1e: d.y1, y1d: y1-d.y1, Tbe: d.Tb, Tbd: T_bubble-d.Tb};
    });

    let T1e = -1, x1e = -1, T2e=-1, x2e=-1;

    if (data.length>0) {
        T1e = T2e = data[0].Tb; x1e=x2e=data[0].x1;
        if (data.length > 1) {
            if (data[1].Tb < T1e){   // T1e is always the smallest, and T2e is second smallest
                T2e = T1e; T1e= data[1].Tb; x2e=x1e; x1e=data[1].x1;
            }
            else {
                T2e=data[1].Tb; x2e=data[1].x1;
            }
        }

        if (azeotrope===1) {
            for (let i = 2; i< data.length; i++) {
                if (data[i].Tb < T1e) {   // new data is the new smallest, then it becomes T1, and T1 becomes T2 
                    T2e = T1e; x2e = x1e;
                    T1e = data[i].Tb; x1e = data[i].x1;
                }
                else if (data[i].Tb < T2e) {
                    T2e = data[i].Tb; x2e = data[i].x1;
                }
            }
        }
        else if (azeotrope===-1){
            for (let i = 2; i< data.length; i++) {
                if (data[i].Tb > T2e) {   // new data is the new smallest, then it becomes T1, and T1 becomes T2 
                    T1e = T2e; x1e = x2e;
                    T2e = data[i].Tb; x2e = data[i].x1;
                }
                else if (data[i].Tb > T1e) {
                    T1e = data[i].Tb; x1e = data[i].x1;
                }
            }
        }

        T1e = (T1e+T2e) * 0.5, x1e = (x1e+x2e) * 0.5;
    }

    return (
        
          
        <tr>
            <td width='190px'>  
                {setting_cap}<br/><br/>

                <i>P</i><sub>0</sub> = <input type="number" step="0.1" min="0.1" max='10.0' placeholder='[0.1-10.0]' class='inputBox2' value={P_in} onChange={P_in_Change}/> {' '+press_unit}
                <br/><br/>
                {(azeotrope!==0) &&  <div>{azeo_T_cap}: {(Tm-273.15).toFixed(2)}<sup>o</sup>C<br/>{azeo_X_cap}: {xm.toFixed(4)}</div>} 
                <br/>

                {dataFormat_cap}
                <button onClick={() => document.getElementById('fileInput').click()}>
                    {addData_cap}
                </button>
                <input  type="file" onChange={handleFileChange} accept='.csv' style={{ display: 'none' }} id="fileInput"/>
                <br/><br/>
                {(azeotrope!==0 && data.length>0) &&  <div>{azeo_Te_cap}: {(T1e-273.15).toFixed(2)}<sup>o</sup>C<br/>{azeo_Xe_cap}: {x1e.toFixed(4)}</div>} 
                <br/>

            </td>

            <td align='center' width='320px'>  
                {txytitle_cap}<br/>
                <OutputGraph bgData={Txy_data} data={data} tMax={tMax} tMin={tMin} lang={lang} />
            </td>

            <td align='center' width='290px'> 
                {xytitle_cap}<br/>
                <OutputGraph_xy bgData={Txy_data} data={data} lang={lang}/>
            </td>

            <td width='200px'>
                {(data.length>0) &&
                <button onClick={() => setData([])}>
                    {clearData_cap}
                </button>}
                <OutputTable_Compare compareData={compareData} lang={lang}/>

            </td>

            
        </tr>        
        

        


    )}

    